export class Mobile {
  /**
   * Checks if an app is running on a mobile device.
   */
  public static isMobile(): boolean {
    return (
      /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(navigator.userAgent) ||
      /\b(Android|Windows Phone|iPad|iPod)\b/i.test(navigator.userAgent) ||
      'orientation' in window
    );
  }
}
